import React, { useMemo } from "react";
import Close from "../Assets/Close";
import PaymentContainer, {
    bgColor,
} from "../PaymentContainer/PaymentContainer";
import styles from "../Payment.module.css";
import Spinner from "../../Spinner/Spinner";
import { Stack } from "@mui/material";
import toRupiah from "../../../utils/toRupiah";
import { Link, useHistory } from "react-router-dom";
import usePaymentOrderDetails from "../usePaymentOrderDetails";

interface IPaymentInformationProps {
    orderId: string;
}

const PaymentInformation = ({ orderId }: IPaymentInformationProps) => {
    const history = useHistory();
    const {
        discount,
        isLoading,
        search,
        selectedLayanan,
        selectedVoucher,
        totalPrice,
    } = usePaymentOrderDetails();

    const RedirectButton = useMemo(
        () => (
            <div style={{ padding: 16 }}>
                <div className={styles.section_float}>
                    <div className={styles.half_focused_text}>
                        Total tagihan
                    </div>
                    <div className={styles.focused_text}>
                        {toRupiah(totalPrice)}
                    </div>
                </div>
                <Link
                    className={styles.button}
                    style={{ backgroundColor: bgColor }}
                    to={`${window.location.pathname}/metode${search}`}
                >
                    Lanjut ke Pembayaran
                </Link>
            </div>
        ),
        [search, totalPrice],
    );

    return (
        <>
            <PaymentContainer
                title="Informasi Pembayaran"
                headerLeft={<Close />}
                onClickHeaderLeft={() => history.goBack()}
                fab={RedirectButton}
            >
                <div className={styles.section}>
                    <div className={styles.section_header}>
                        <div className={styles.half_focused_text}>Order ID</div>
                        <div className={styles.focused_text}>
                            {orderId ?? ""}
                        </div>
                    </div>
                </div>
                <div className={styles.spacer} />
                {isLoading ? (
                    <Stack
                        display="grid"
                        gridTemplateColumns="1fr"
                        alignItems="center"
                        height={400}
                        position="relative"
                    >
                        <Spinner />
                    </Stack>
                ) : (
                    <div className={styles.section}>
                        <div className={styles.section_header}>
                            <div className={styles.half_focused_text}>
                                Detail Pesanan
                            </div>
                        </div>
                        <div className={styles.product}>
                            <div className={styles.product_container}>
                                <div className={styles.product_info}>
                                    <div className={styles.info_title}>
                                        {selectedLayanan?.nama}
                                    </div>
                                    <div
                                        className={[
                                            styles.info_subtitle,
                                            styles.half_focused_text,
                                        ].join(" ")}
                                    >
                                        {selectedLayanan?.deskripsiLayanan}
                                    </div>
                                </div>
                                <div
                                    className={[
                                        styles.product_price,
                                        styles.focused_text,
                                    ].join(" ")}
                                >
                                    {toRupiah(selectedLayanan?.harga ?? 0)}
                                </div>
                            </div>
                            {selectedVoucher && (
                                <div className={styles.product_container}>
                                    <div className={styles.product_info}>
                                        <div className={styles.info_title}>
                                            Voucher
                                        </div>
                                        {selectedVoucher.deskripsi && (
                                            <div
                                                className={[
                                                    styles.info_subtitle,
                                                    styles.half_focused_text,
                                                ].join(" ")}
                                            >
                                                {selectedVoucher.deskripsi}
                                            </div>
                                        )}
                                    </div>
                                    <div
                                        className={styles.focused_text}
                                        style={{ color: "#1BA86B" }}
                                    >
                                        - {toRupiah(discount)}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </PaymentContainer>
        </>
    );
};

export default PaymentInformation;
